"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.OpenApiSchema = void 0;
const utils_1 = require("@dev-stream/utils");
const utils_2 = require("@dev-stream/utils");
const dictionary_1 = require("../dictionary");
const dictionaries_1 = require("./dictionaries");
const dictionaries_2 = require("./dictionaries");
const dictionaries_3 = require("./dictionaries");
const discriminator_1 = require("./discriminator");
const documentation_1 = require("./documentation");
const extensions_1 = require("./extensions");
const reference_1 = require("./reference");
const xml_1 = require("./xml");
class OpenApiSchema extends utils_1.BaseModel {
    constructor() {
        super(...arguments);
        this.BASE_TYPE = OpenApiSchema;
    }
    GetDefaultValue() {
        return {};
    }
    static isOpenApiSchema(obj) {
        return (obj instanceof OpenApiSchema ||
            (0, utils_2.hasUnionKeys)(obj, [
                "additionalItems",
                "additionalProperties",
                "allOf",
                "anyOf",
                "default",
                "definitions",
                "dependencies",
                "deprecated",
                "description",
                "discriminator",
                "enum",
                "example",
                "exclusiveMaximum",
                "exclusiveMinimum",
                "externalDocs",
                "format",
                "items",
                "maxItems",
                "maxLength",
                "maxProperties",
                "maximum",
                "minItems",
                "minLength",
                "minProperties",
                "minimum",
                "multipleOf",
                "not",
                "nullable",
                "oneOf",
                "pattern",
                "patternProperties",
                "properties",
                "readOnly",
                "required",
                "title",
                "type",
                "uniqueItems",
                "writeOnly",
                "xml",
            ]));
    }
}
__decorate([
    (0, utils_1.Property)(() => (0, utils_1.createTypeMap)([
        [reference_1.OpenApiReference.isOpenApiReference, reference_1.OpenApiReference],
        [
            (o) => (0, dictionary_1.not)(reference_1.OpenApiReference.isOpenApiReference)(o) &&
                OpenApiSchema.isOpenApiSchema(o),
            OpenApiSchema,
        ],
    ]))
], OpenApiSchema.prototype, "items", void 0);
__decorate([
    (0, utils_1.Property)(() => (0, utils_1.createTypeMap)([
        [(obj) => typeof obj == "boolean", null],
        [(obj) => typeof obj != "boolean", OpenApiSchema],
    ]))
], OpenApiSchema.prototype, "additionalItems", void 0);
__decorate([
    (0, utils_1.Property)(() => dictionaries_1.OpenApiSchemaOrReferenceDict)
], OpenApiSchema.prototype, "properties", void 0);
__decorate([
    (0, utils_1.Property)(() => (0, utils_1.createTypeMap)([
        [(obj) => typeof obj == "boolean", null],
        [
            [
                (obj) => typeof obj != "boolean",
                reference_1.OpenApiReference.isOpenApiReference,
            ],
            reference_1.OpenApiReference,
        ],
        [
            [
                (obj) => typeof obj != "boolean",
                (0, dictionary_1.not)(reference_1.OpenApiReference.isOpenApiReference),
                OpenApiSchema.isOpenApiSchema,
            ],
            OpenApiSchema,
        ],
    ]))
], OpenApiSchema.prototype, "additionalProperties", void 0);
__decorate([
    (0, utils_1.Property)(() => dictionaries_3.OpenApiSchemaDependenciesDict)
], OpenApiSchema.prototype, "dependencies", void 0);
__decorate([
    (0, utils_1.Property)(() => OpenApiSchema)
], OpenApiSchema.prototype, "allOf", void 0);
__decorate([
    (0, utils_1.Property)(() => OpenApiSchema)
], OpenApiSchema.prototype, "anyOf", void 0);
__decorate([
    (0, utils_1.Property)(() => OpenApiSchema)
], OpenApiSchema.prototype, "oneOf", void 0);
__decorate([
    (0, utils_1.Property)(() => OpenApiSchema)
], OpenApiSchema.prototype, "not", void 0);
__decorate([
    (0, utils_1.Property)(() => dictionaries_2.OpenApiSchemaDict)
], OpenApiSchema.prototype, "definitions", void 0);
__decorate([
    (0, utils_1.Property)(() => discriminator_1.OpenApiDiscriminator)
], OpenApiSchema.prototype, "discriminator", void 0);
__decorate([
    (0, utils_1.Property)(() => xml_1.OpenApiXml)
], OpenApiSchema.prototype, "xml", void 0);
__decorate([
    (0, utils_1.Property)(() => documentation_1.OpenApiExternalDocumentation)
], OpenApiSchema.prototype, "externalDocs", void 0);
__decorate([
    (0, utils_1.Property)(() => extensions_1.SwaggerExplorerExtension)
], OpenApiSchema.prototype, "x-swagger-explorer", void 0);
exports.OpenApiSchema = OpenApiSchema;
